module.exports = __webpack_public_path__ + "static/img/back_home.e452445.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/led/back_home.png
// module id = JH55
// module chunks = 4